import './rf_plan_auto_add_transmitters.component.scss';

export interface AutoAddRFPlanConfig {
    createPer: CREATE_PER;
    assetTypes: Array<number>;
    ipDeviceTypes: Array<number>;
    radioChannel: RADIO_CHANNEL_OPTION;
}

export enum RADIO_CHANNEL_OPTION {
    ALL_RADIOS,
    ONLY_2_4_GHZ,
    ONLY_5_GHZ,
}

export enum CREATE_PER {
    ASSET,
    RADIO,
}
